import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { NddLocationMetrics, NddHierarchyMetrics, NddApiProps } from 'types/ndd'

export const fetchNddLocationMetrics = async ({
    env,
    accessToken,
    locationId,
}: NddApiProps): Promise<NddLocationMetrics> => {
    const fetchFunction = fetchGeneralData<NddLocationMetrics>(
        `${ApiSubUrls[Apis.FULFILLMENT]}/ndd_metrics/locations`,
    )

    return fetchFunction({
        env,
        accessToken,
        filters: {
            location_id: locationId,
        },
    })
}

export const fetchNddRegionMetrics = async ({
    env,
    accessToken,
    locationId,
}: NddApiProps): Promise<NddHierarchyMetrics> => {
    const fetchFunction = fetchGeneralData<NddHierarchyMetrics[]>(
        `${ApiSubUrls[Apis.FULFILLMENT]}/ndd_metrics/regions`,
    )

    const result = await fetchFunction({
        env,
        accessToken,
        filters: {
            region_id: locationId, // Keep as string for filter interface
        },
    })

    return result[0]
}

export const fetchNddGroupMetrics = async ({
    env,
    accessToken,
    locationId,
}: NddApiProps): Promise<NddHierarchyMetrics> => {
    const fetchFunction = fetchGeneralData<NddHierarchyMetrics[]>(
        `${ApiSubUrls[Apis.FULFILLMENT]}/ndd_metrics/groups`,
    )

    const result = await fetchFunction({
        env,
        accessToken,
        filters: {
            group_id: locationId,
        },
    })

    return result[0]
}

export const fetchNddDistrictMetrics = async ({
    env,
    accessToken,
    locationId,
}: NddApiProps): Promise<NddHierarchyMetrics> => {
    const fetchFunction = fetchGeneralData<NddHierarchyMetrics[]>(
        `${ApiSubUrls[Apis.FULFILLMENT]}/ndd_metrics/districts`,
    )

    const result = await fetchFunction({
        env,
        accessToken,
        filters: {
            district_id: locationId,
        },
    })

    return result[0]
}

export const fetchNddTargetMetrics = async ({
    env,
    accessToken,
}: Omit<NddApiProps, 'locationId'>): Promise<NddHierarchyMetrics> => {
    const fetchFunction = fetchGeneralData<NddHierarchyMetrics[]>(
        `${ApiSubUrls[Apis.FULFILLMENT]}/ndd_metrics`,
    )

    const result = await fetchFunction({
        env,
        accessToken,
    })

    return result[0]
}

export const fetchNddHistoricalData = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
